import React from "react";
import DataGrid from './data-grid';
import { Tooltip } from '@progress/kendo-react-tooltip';
import currencyFormat from "../functions/currency";
export default class ProductGrid extends React.Component {
  render() {
    var data = this.props.data;
    var columns = [{
      field: 'imageLink',
      title: 'Image',
      sortable: false,
      cell: props => {
        var row = props.dataItem;
        var imageLink = row.imageLink;
        var split = imageLink.split('?');
        var imageSrc = split[0] + '?width=50';
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
          src: imageSrc,
          onError: ({
            currentTarget
          }) => {
            currentTarget.onerror = null;
            currentTarget.src = 'https://s3.amazonaws.com/app.plunk.io/images/image-404.png';
          }
        })));
      }
    }, {
      field: 'title',
      title: 'Title',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Tooltip, {
          anchorElement: "target",
          position: "top"
        }, /*#__PURE__*/React.createElement("a", {
          href: row.link,
          target: "_blank",
          title: row.title
        }, row.title)));
      }
    }, {
      field: 'id',
      title: 'Sku',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, row.id));
      }
    }, {
      field: 'price',
      title: 'Price',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, currencyFormat(row.price));
      }
    }, {
      field: 'availability',
      title: 'Availability',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, row.availability));
      }
    }];
    return /*#__PURE__*/React.createElement(DataGrid, {
      data: data,
      columns: columns,
      pageSize: 10,
      pagination: this.props.pagination,
      onPageRequest: this.props.onPageRequest
    });
  }
}